import styled from 'styled-components';
import colors from 'constants/colors';

export const Head = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  height: 100%;
`;

export const Content = styled.div`
  width: 500px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  row-gap: 24px;

  .text {
    color: ${colors.white};
    margin: 25px 0 15px 0;
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  column-gap: 16px;

  .address, .city, .province, .zipCode, .country {
    width: 100%;
    min-width: 60px;
    position: relative;

    .label {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  
  ${({ additionalstyle }) => additionalstyle};
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
`;